<div class="container-report">
  <div class="container-top">
    <header>
      <h1>{{ 'report-and-results.title' | translate }}</h1>
      <p>{{ 'report-and-results.description' | translate }}</p>
    </header>

    <div class="pulsanti">
      <button class="eportButton" (click)="exportPdf()" [disabled]="!report">
        <mat-icon>import_export</mat-icon>{{ 'report-and-results.export' | translate }}
      </button>
    </div>
  </div>

  <div class="container-bottom">
    <div class="container-1">
      {{
        'report-and-results.intro' | translate:{
          inclusionIndex: (report?.inclusionIndex | number:'1.1-2'),
          inclusionLevel: report?.inclusionLevel,
          letterGrade: report?.letterGrade
        }
      }}
    </div>

    <div class="container-2" *ngIf="report">
      <div class="graphic">
        <h2><mat-icon>business</mat-icon> {{ 'report-and-results.company-inclusion-index' | translate }}</h2>
        <div #radarChartHost id="radarChart" class="self-assessment"></div>
      </div>

      <div class="analysis">
        <h2>{{ 'report-and-results.detailed-analysis' | translate }}</h2>

        <mat-accordion class="example-headers-align">
          @for (dimension of dimensionsInfo; track $index) {
          <mat-expansion-panel [expanded]="false" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                @if($index == 0){
                  <mat-icon>leaderboard</mat-icon>
                }
                @else if ($index == 1) {
                  <mat-icon>chat</mat-icon>   
                }
                @else if ($index == 2) {
                  <mat-icon>groups</mat-icon>   
                }
                @else if ($index == 3) {
                  <mat-icon>school</mat-icon>  
                }
                @else {
                  <mat-icon>support</mat-icon>
                }
                {{ translateDimensionName(dimension.name) }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="content">
              <div class="dimension-summary">
                {{
                  'report-and-results.dimension-summary' | translate:{
                    name: translateDimensionName(dimension.name),
                    score: (dimension.score | number:'1.1-2')
                  }
                }}
              </div>

              <div class="dimension-criticalities">
                <div class="dimension-title">
                  <mat-icon class="errore">warning</mat-icon> {{ 'report-and-results.dimension-criticalities-title' | translate }}
                </div>
                <div class="subtitle">{{ 'report-and-results.dimension-criticalities-subtitle' | translate }}</div>
                <ul>
                  @for (criticAnswer of dimension.criticAnswers; track $index) {
                  <li>{{ criticAnswer | translate }}</li>
                  }
                </ul>
              </div>

              <div class="dimension-improvements">
                <div class="dimension-title">
                  <mat-icon class="ok">check_circle</mat-icon> {{ 'report-and-results.dimension-improvements-title' | translate }}
                </div>
                <div class="subtitle">
                  {{ 'report-and-results.dimension-improvements-subtitle' | translate }}
                </div>
                <ul>
                  @for (improvementAreas of dimension.improvementAreas; track $index) {
                  <li>{{ improvementAreas | translate}}</li>
                  }
                </ul>
              </div>
            </div>
          </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    </div>
  </div>
</div>
